import { make } from 'vuex-pathify'
import rpc from '../../api/rpc'

const state = {
  login_attempts: null
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  async login_attemptsFetch ({ commit }) {
    const response = await rpc('users.login_attempts_fetch')
    if (response) {
      commit('SET_LOGIN_ATTEMPTS', response)
      return true
    }
  }
}

export default { state, actions, mutations, namespaced }
